<template lang="pug">
  div
    SingleNumWrapper(
      :chartType="'cachedratenum'"
      :chartTitle="$t('dashboard.cachedRate')"
      :numeralFormat="'0.00%'"
      :maxFontSize="'42px'"
      :withCard="withCard"
    )
    PieChartWrapper(
      :chartType="'cacheStatusPieChart'"
      :chartTitle="$t('dashboard.cacheRatioText')"
      :topNSize="2"
      :numeralFormat="'0.00b'"
      :titleDisplay="false"
      :withCard="withCard"
      :chartWidth="600"
      :chartHeight="100"
      :useGuage="true"
      :pieBackgroundColors="[[colorScheme.blue.fill]]"
      :legendDisplay="false"
      :withPropRawBtn="false"
      )
</template>
<script>
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import PieChartWrapper from "@/components/dashboard/PieChartWrapper";

import colorScheme from "@/data/colorScheme";

export default {
    components: { SingleNumWrapper, PieChartWrapper },
    props: {
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        withCard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            colorScheme: colorScheme
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage/AccelerationCard.vue